import {
    ADD_ATTRIBUT_ROW_SUCCESS,
    REMOVE_ATTRIBUT_ROW_SUCCESS,
    UPDATE_ATTRIBUT_ROW_SUCCESS,
    CLEAR_ATTRIBUT_ROW_SUCCESS,
  } from "../../actions/createGridAttribut/type";
  
  const initialState = {
    usersRow: [],
    keyIndex: 0,
    attributesRow: [],
    attributesIndex: 0,
  };
  
  const createGridAttribut = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
    
      //***attributes cases***
      case ADD_ATTRIBUT_ROW_SUCCESS:
        return {
          ...state,
          attributesRow: [...state.attributesRow, payload],
          attributesIndex: state.attributesIndex + 1,
        };
  
      case REMOVE_ATTRIBUT_ROW_SUCCESS:
        return {
          ...state,
          attributesRow: state.attributesRow.filter((item) => Number(item.attributesIndex) !== payload),
        };
  
      case UPDATE_ATTRIBUT_ROW_SUCCESS:
        return {
          ...state,
          attributesRow: state.attributesRow.map((row) => {
            if (row.attributesIndex === payload.attributesIndex) {
              return {
                ...row,
                ...payload,
              };
            } else {
              return row;
            }
          }),
        };
  
      case CLEAR_ATTRIBUT_ROW_SUCCESS:
        return {
          ...state,
          attributesRow: payload,
          attributesIndex: 0,
        };
  
      default:
        return state;
    }
  };
  
  export default createGridAttribut;
  